import { QuerySwitch } from 'components/QuerySwitch';
import { FetchSelectedAgenciesRateDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchSelectedAgenciesRate.data.context';
import { FetchSelectedMarketplaceCommunitiesRateDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchSelectedMarketplaceCommunitiesRate.data.context';
import {
  FetchCombinedSummaryRatesDataContext,
  FetchCombinedSummaryRatesDataProvider,
} from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchCombinedSummaryRates.data.context';
import { SelectedAgenciesPayComponent } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/ShiftPay/SelectedAgenciesPay/SelectedAgenciesPay.component';
import { FC } from 'react';

export const SelectedAgenciesPay: FC = () => {
  return (
    <FetchSelectedAgenciesRateDataProvider>
      <FetchSelectedMarketplaceCommunitiesRateDataProvider>
        <FetchCombinedSummaryRatesDataProvider>
          <QuerySwitch
            component={SelectedAgenciesPayComponent}
            context={FetchCombinedSummaryRatesDataContext}
          />
        </FetchCombinedSummaryRatesDataProvider>
      </FetchSelectedMarketplaceCommunitiesRateDataProvider>
    </FetchSelectedAgenciesRateDataProvider>
  );
};
